<template>
  <el-row class="advantage_wrap">
    <el-col
      class="advantage_item"
      v-for="(item, index) in advantageList"
      :key="index"
      :span="5"
      :xs="11"
    >
      <img :src="item.img" alt="Image" class="responsive-img" />
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      advantageList: [],
    }
  },
  methods: {
    getImageList(locale) {
      const isEnglish = locale === 'en';
      const suffix = isEnglish ? '-en' : '';
      return Array.from({ length: 4 }, (_, i) => ({
        img: require(`../../assets/img/carbon/report/zztbg-${i + 1}${suffix}.png`),
      }));
    },
  },
  watch: {
    '$i18n.locale'(newLocale) {
      this.advantageList = this.getImageList(newLocale);
    },
  },
  created() {
    this.advantageList = this.getImageList(this.$i18n.locale);
  },
}
</script>

<style lang="scss" scoped>
.advantage_wrap {
  width: 80%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @media screen and (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }

  .advantage_item {
    height: auto;
    padding: 20px 20px 20px 12px;
    margin-right: 10px;
    background: #f0f5fd 0 0 no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    @media screen and (max-width: 768px) {
      margin: 0;
      padding: 0 15px;
      margin-top: 3px;
      height: 240px;
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 100%;
      overflow: hidden;
    }
  }

  .responsive-img {
    width: 100%;
    height: auto;
    max-width: 100%;
  }
}
</style>
